import PropTypes from "prop-types";
import * as React from "react";
import { Button, Dialog } from "../../themeV2";
import css from "./ShopImagesEditor.module.css";

export default function EditorActions({
  step,
  onBack,
  onNext,
  onSave,
  onDone,
}) {
  if (!step) {
    return (
      <Dialog.Actions>
        <Button variant="filled" onClick={onDone}>
          Done
        </Button>
      </Dialog.Actions>
    );
  }

  return (
    <Dialog.Actions
      start={
        <div className={css.stepButtons}>
          <Button variant="text" onClick={onBack}>
            {step.isFirst ? "Cancel" : "Back"}
          </Button>
          {!step.isLast && (
            <Button variant="tonal" onClick={onNext}>
              Next
            </Button>
          )}
        </div>
      }
    >
      <Button variant="filled" onClick={onSave}>
        {step.saveLabel}
      </Button>
    </Dialog.Actions>
  );
}

EditorActions.propTypes = {
  step: PropTypes.shape({
    isFirst: PropTypes.bool,
    isLast: PropTypes.bool,
    saveLabel: PropTypes.string.isRequired,
  }),
  onBack: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
};
